

let difference={  //是否是正式发布的功能
    production:true,
    development:true
}

let editions={  //不同版本
    uat:0,
    localization:1
}



export let env= difference[process.env.NODE_ENV] 

export let edition=process.env.VUE_APP_BASE_API?editions[process.env.VUE_APP_BASE_API]:editions['uat']
 
